import Layout from 'layouts/Layout/Layout'
import classNames from 'classnames'
import styles from './SideAndMainLayout.module.scss'

interface SideAndMainLayoutProps {
  aside: JSX.Element | null
  main: JSX.Element | null
  asideClassName?: string
  mainClassName?: string
}

const defaultProps = {
  asideClassName: undefined,
  mainClassName: undefined,
}

const SideAndMain = ({
  aside,
  main,
  asideClassName,
  mainClassName,
}: SideAndMainLayoutProps): JSX.Element => (
  <Layout className={styles.sideAndMain}>
    {aside && (
      <aside
        className={classNames('aside', styles.aside, asideClassName, {
          [styles.old]: process?.env?.REACT_APP_RELEASE_TOGGLE_V2 !== 'true',
        })}
      >
        {aside}
      </aside>
    )}
    {main && (
      <section className={classNames('main', styles.main, mainClassName)}>
        {main}
      </section>
    )}
  </Layout>
)

SideAndMain.defaultProps = defaultProps
export default SideAndMain
